import { useState } from 'react';
import xorBy from 'lodash/xorBy';
import xor from 'lodash/xor';
import { RoleSelection } from '../../components/Roles/roles.types';

type Arg = string[] | RoleSelection[];
type Callback = (value: Arg) => void;

const useRoleState = (): [any[], Callback] => {
  const [roles, setRoles] = useState<string[] | RoleSelection[]>([]);

  const updateIfHasOrganisation = (role: RoleSelection) => {
    const orgRoles = roles as RoleSelection[];
    const isMatching = (selectedRole: RoleSelection) =>
      selectedRole.org === role.org && selectedRole.id === role.id;

    const isExist = orgRoles.find(isMatching);

    if (isExist) {
      const rolesWithSelectedRemoved = orgRoles.filter(
        (selectedRole) => !isMatching(selectedRole),
      );
      setRoles(rolesWithSelectedRemoved);
    } else {
      setRoles([...orgRoles, role]);
    }
  };

  const onSetRoles = (value: any) => {
    if (Array.isArray(value)) {
      setRoles(value);
    } else {
      if (typeof value === 'string') {
        // @ts-ignore
        setRoles(xor([value], roles));
      } else {
        if (value.org) {
          updateIfHasOrganisation(value);
        } else {
          setRoles(xorBy([value], roles, 'id'));
        }
      }
    }
  };

  return [roles, onSetRoles];
};

export default useRoleState;
